import { Card, FlexRow, Grid, IconType, RotatingIcon } from '../../../../../ui-toolkit';
import React from 'react';
import { CreateEditCheckDepositsContainer } from '../../deposits/checkDeposits/CreateEditCheckDepositsContainer';
import { useFormikContext } from 'formik';
import { IEscrowFileCompleteData } from '../../../../../types/order/escrow/IEscrowFileCompleteData';
import { SpaEscrowSubmitButton } from './SpaEscrowSubmitButton';
import { CreateEditAchPullDepositsContainer } from '../../deposits/achPullDeposits/CreateEditAchPullDepositsContainer';
import { CreateEditWireDepositsContainer } from '../../deposits/wireDeposits/CreateEditWireDepositsContainer';
import { IParty } from '../../../../../ui-toolkit/orders/interfaces/IParty';
import { IPartyPerson } from '../../../../../ui-toolkit/orders/interfaces/IPartyPerson';

interface ICreateEditIncomingFormCardProps {
  borrowersSellers: IParty[];
  escrowFileId: string;
  formChangeFetching: boolean;
  onTransactionUpdate: () => void;
  onFormSubmit: (formData: IEscrowFileCompleteData, touched: any) => Promise<void>;
}

export const SpaCreateEditIncomingFormCard: React.FC<ICreateEditIncomingFormCardProps> = ({
  borrowersSellers,
  escrowFileId,
  formChangeFetching,
  onTransactionUpdate,
  onFormSubmit,
}) => {
  const { dirty } = useFormikContext<IEscrowFileCompleteData>();
  return (
    <Card title={'Incoming'} isCollapsible>
      <Grid>
        <CreateEditAchPullDepositsContainer
          escrowFileId={escrowFileId}
          dirty={dirty}
          parties={borrowersSellers as IPartyPerson[]}
          onTransactionUpdate={onTransactionUpdate}
        />
        <CreateEditWireDepositsContainer dirty={dirty} onTransactionUpdate={onTransactionUpdate} />
        <CreateEditCheckDepositsContainer dirty={dirty} onTransactionUpdate={onTransactionUpdate} />
        <FlexRow justifyContent={'end'}>
          {formChangeFetching && <RotatingIcon type={IconType.Loading} />}
          <SpaEscrowSubmitButton onFormSubmit={onFormSubmit} />
        </FlexRow>
      </Grid>
    </Card>
  );
};
